import React, { useState } from 'react';
import { PlayCircleIcon } from 'lucide-react';
import { VideoModal } from './VideoModal';
const PLAYBOOK_VIDEO_URL = 'https://www.youtube.com/embed/d0PXfzexj4M?si=WxnTloThEfqlgXhZ';
interface WatchPlaybookButtonProps {
  className?: string;
  children?: ReactNode;
  showIcon?: boolean;
}
export function WatchPlaybookButton({
  className = 'btn-outline whitespace-nowrap inline-flex items-center gap-2',
  children = 'New Career Playbook',
  showIcon = true
}: WatchPlaybookButtonProps) {
  const [open, setOpen] = useState(false);
  return <>
      <button type="button" onClick={() => setOpen(true)} className={className} data-id="element-205">
        {showIcon && <PlayCircleIcon className="w-5 h-5" data-id="element-206" />}
        {children}
      </button>
      <VideoModal open={open} onClose={() => setOpen(false)} videoUrl={PLAYBOOK_VIDEO_URL} data-id="element-207" />
    </>;
}